import './App.scss';
import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './components/Home';
import About from './components/About';
import MovieReview from './components/MovieReview';

function App() {
  return (
    <div className='App'>
      <Switch>
        <Route
          exact
          path='/'
          render={(routeprops) => {
            return (
              <Layout {...routeprops}>
                <MovieReview />
              </Layout>
            );
          }}
        />
        <Route
          exact
          path='/top-20-news-articles'
          render={(routeprops) => {
            return (
              <Layout {...routeprops}>
                <Home />
              </Layout>
            );
          }}
        />
        <Route
          exact
          path='/about-author'
          render={(routeprops) => {
            return (
              <Layout {...routeprops}>
                <About />
              </Layout>
            );
          }}
        />
        <Route>
          <Redirect to='/' />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
